import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-my-pets-page',
  templateUrl: './my-pets-page.component.html',
  styleUrls: ['./my-pets-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MyPetsPageComponent {

}
